
    import '/opt/buildhome/repo/components/useXAgent/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["components-use-x-agent-demo-preset","components-use-x-agent-demo-custom"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/useXAgent/index.zh-CN.md?type=demo')
};